import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

const FooterNav = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-nav',
    className
  );

  return (
    <nav
      {...props}
      className={classes}
    >
      <ul className="list-reset">
        <li>
          <a href="#/" onClick={(e) => { e.preventDefault(); if (window.location.hash !== '#/') window.location.hash = '#/'; setTimeout(() => { const el = document.getElementById('contact'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }, 100); }}>Contact</a>
        </li>
        <li>
          <a href="#/" onClick={(e) => { e.preventDefault(); if (window.location.hash !== '#/') window.location.hash = '#/'; setTimeout(() => { const el = document.getElementById('features'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }, 100); }}>Features</a>
        </li>
        <li>
          <a href="#/" onClick={(e) => { e.preventDefault(); if (window.location.hash !== '#/') window.location.hash = '#/'; setTimeout(() => { const el = document.getElementById('solutions'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }, 100); }}>Solutions</a>
        </li>
      </ul>
    </nav>
  );
}

export default FooterNav;